import React, { Fragment, useState } from "react"
import { Helmet } from "react-helmet"




//componets
import ThemeMenuThree from "../../../components/header/ThemeMenuThree"
import PageTitle from "../../../components/page-title/PageTitle"
import CommonCounter from "../../../components/counter/CommonCounter"
import ProjectMasonryTwo from "../../../components/project/ProjectMasonryTwo"
import ServiceCategory from "../../../components/widget/ServiceCategory"
import WidgetForm from "../../../components/form/WidgetForm"
import ModalVideos from "../../../components/modal-video/ModalVideos"
import CaseSliderOne from "../../../components/case-study/CaseSliderOne"
import NewsletterTwo from "../../../components/call-to-action/NewsletterTwo"
import FooterThree from "../../../components/footer/FooterThree"



const ProjectDetails = () => {
    const [open, setOpen] = useState(false);
    const OpenModal = () => {
        setOpen(!open)
    }
    return (
        <Fragment>
            <ModalVideos isOpen={open} onClick={OpenModal} />
            <div className="main-page-wrapper">
                {/* Helmet start */}
                <Helmet>
                    <title>Detalle del Proyecto – Caso de Éxito</title>
                    <meta name="description" content="Conoce en detalle este proyecto tecnológico de CuySoft. Casos de éxito en desarrollo de software y soluciones digitales en Ecuador." />
                    <link rel="canonical" href="https://www.cuysoft.com/project-details" />
                </Helmet>
                {/* Helmet end */}

                {/* ThemeMenuThree */}
                <ThemeMenuThree />
                {/* ThemeMenuThree */}

                {/* PageTitle */}
                <PageTitle title="Detalles del Proyecto" />
                {/* PageTitle */}

                {/*project-details-wrapper start*/}
                <section className="project-details-wrapper pt-145 pb-30 pt-lg-60 pb-lg-20">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center justify-content-center">
                            <div className="col-lg-12">
                                <div className="project-details-content-top mb-50">
                                    <h2 className="sect-title mb-20">Diseño Para el Futuro</h2>
                                    <p className="text-white mb-35">Integramos rápidamente usuarios centrados en el cliente a través de datos
                                        verticales. Reutilizamos de manera holística la experiencia interactiva tras recursos distintivos.
                                        Diseñamos colaborativamente imperativos prospectivos con tecnología transparente.
                                        Transformamos excelentes materiales para la colaboración multifuncional y
                                        el intercambio de ideas. Innovamos continuamente en comercio electrónico mantenible sin
                                        relaciones a prueba de futuro.</p>
                                </div>
                                <div className="project-info d-flex justify-content-end mb-60">
                                    <div className="info-box">
                                        <h4 className="semi-title mb-20">Información del Proyecto</h4>
                                        <div className="box d-md-flex align-items-center">
                                            <ul className="list-none pe-5">
                                                <li>
                                                    <div className="info-list">
                                                        <span>Cliente</span>
                                                        <h5>Frndz IT LTD.</h5>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="info-list">
                                                        <span>Fecha de Inicio</span>
                                                        <h5>21 Junio 2022</h5>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="info-list">
                                                        <span>Duración del Proyecto</span>
                                                        <h5>03 Meses</h5>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="info-list">
                                                        <span>Fecha de Finalización</span>
                                                        <h5>21 Sept 2022</h5>
                                                    </div>
                                                </li>
                                            </ul>
                                            <ul className="list-none">
                                                <li>
                                                    <div className="info-list">
                                                        <span>Tipo de Proyecto</span>
                                                        <h5>Soluciones IT</h5>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="info-list">
                                                        <span>Ubicación</span>
                                                        <h5>Dhaka, Bangladesh</h5>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="info-list">
                                                        <span>Empleados</span>
                                                        <h5>10 Personas</h5>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="info-list">
                                                        <span>Resultados</span>
                                                        <h5>Muy Buenos</h5>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="info-list">
                                            <span>Etiqueta</span>
                                            <h5>Ciber / Solución / Protección</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-lg-8">
                                <div className="widget-left-section">
                                    <p className="text-white mb-55">Integramos rápidamente usuarios centrados en el cliente a través de
                                        datos
                                        verticales.
                                        Reutilizamos de manera holística la experiencia interactiva tras recursos distintivos.
                                        Diseñamos colaborativamente imperativos prospectivos con tecnología transparente.
                                        Transformamos excelentes materiales para la colaboración multifuncional y
                                        el intercambio de ideas. Innovamos continuamente en comercio electrónico mantenible sin
                                        relaciones a prueba de futuro.</p>
                                    <hr />
                                    <h3 className="sect-title-two fw-bold mb-20 mt-55">Desafío</h3>
                                    <p className="text-white mb-35">Integramos rápidamente usuarios centrados en el cliente a través de datos
                                        verticales.
                                        Reutilizamos de manera holística la experiencia interactiva tras recursos distintivos.
                                        Diseñamos colaborativamente imperativos prospectivos con tecnología transparente.
                                        Transformamos excelentes materiales para la colaboración multifuncional y
                                        el intercambio de ideas. Innovamos continuamente en comercio electrónico mantenible sin
                                        relaciones a prueba de futuro.</p>
                                    <ul className="text-list list-none">
                                        <li>Diseñamos colaborativamente imperativos prospectivos con tecnología transparente.
                                        </li>
                                        <li>Transformamos excelentes materiales para la colaboración multifuncional
                                            y el intercambio de ideas.</li>
                                        <li>Cultivamos convenientemente procesos convincentes ante redes centradas en el cliente.
                                        </li>
                                    </ul>
                                    <div className="service-video d-md-flex mt-10">
                                        <div className="service-single-video mb-30">
                                            <img className="w-100" src="assets/img/work/big-img-02.jpg" alt="img" />
                                            <a className="popup-video mb-30" onClick={OpenModal} ><i className="bi bi-play-fill" /></a>
                                        </div>
                                    </div>
                                    <hr />
                                    <h3 className="sect-title-two fw-bold mb-20 mt-55">Objetivos del Proyecto</h3>
                                    <p className="text-white">Integramos rápidamente usuarios centrados en el cliente a través de datos verticales.
                                        Reutilizamos de manera holística la experiencia interactiva tras recursos distintivos.
                                        Diseñamos colaborativamente imperativos prospectivos con tecnología transparente.
                                        Transformamos excelentes materiales para la colaboración multifuncional y
                                        el intercambio de ideas. Innovamos continuamente en comercio electrónico mantenible sin
                                        relaciones a prueba de futuro.</p>
                                    <div className="row gx-4 gx-xxl-5 mt-40">
                                        <div className="col-md-3 col-sm-6" data-aos="fade-up">
                                            <div className="counter-style-two boder-style mb-45">
                                                <h3><span className="counter"><CommonCounter value="125" /></span>+</h3>
                                                <p className="text-white mt-20">Desarrollamos Más de 125+ Software</p>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-sm-6" data-aos="fade-up">
                                            <div className="counter-style-two boder-style mb-45">
                                                <h3><span className="counter"><CommonCounter value="64" /></span>+</h3>
                                                <p className="text-white mt-20">Clientes Globales que Confían en Nosotros</p>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-sm-6" data-aos="fade-up">
                                            <div className="counter-style-two boder-style mb-45">
                                                <h3><span className="counter"><CommonCounter value="32" /></span>+</h3>
                                                <p className="text-white mt-20">Premios Locales
                                                    y Globales Ganados</p>
                                            </div>
                                        </div>
                                        <div className="col-md-3 col-sm-6" data-aos="fade-up">
                                            <div className="counter-style-two boder-style mb-45">
                                                <h3><span className="counter"><CommonCounter value="122" /></span>+</h3>
                                                <p className="text-white mt-20">Reseñas de Clientes sobre Nuestro Software</p>
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="mt-10 mb-55" />
                                    <h3 className="sect-title-two fw-bold mb-20">Soluciones</h3>
                                    <p className="text-white mb-40">Integramos rápidamente usuarios centrados en el cliente a través de datos
                                        verticales.
                                        Reutilizamos de manera holística la experiencia interactiva tras recursos distintivos.
                                        Diseñamos colaborativamente imperativos prospectivos con tecnología transparente.</p>
                                    {/* ProjectMasonryTwo start */}
                                    <ProjectMasonryTwo />
                                    {/* ProjectMasonryTwo end */}
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="widget-right-section">
                                    {/* ServiceCategory start */}
                                    <ServiceCategory />
                                    {/* ServiceCategory end */}
                                    <div className="widget-file-download mt-60">
                                        <button>Descargar PDF 01 <i className="bi bi-file-earmark-arrow-down" /></button>
                                        <button>Descargar PDF 02 <i className="bi bi-file-earmark-arrow-down" /></button>
                                    </div>
                                    <div className="widget-form mt-60">
                                        <h3 className="widget-title mb-20">Contáctanos</h3>
                                        <p className="mb-40">Diseñamos colaborativamente imperativos
                                            prospectivos con tecnología transparente.</p>
                                        {/* WidgetForm start*/}
                                        <WidgetForm />
                                        {/* WidgetForm end */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/*project-details-wrapper end*/}

                {/*latest-case-work start*/}
                <section className="latest-case-work slick-nav blog-slick-two pt-75 pb-150 pt-lg-65">
                    <img className="case-shape shape-1b" src="assets/img/shape/star-3b.svg" alt="shape" />
                    <img className="case-shape shape-2b" src="assets/img/shape/star-4b.svg" alt="shape" />
                    <img className="case-shape shape-3b d-none d-lg-inline-block" src="assets/img/shape/star-2.svg" alt="shape" />
                    <img className="case-shape shape-4b" src="assets/img/shape/star-5b.svg" alt="shape" />
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center">
                            <div className="col-xl-5 col-lg-6 col-md-8">
                                <div className="section-title mb-55 text-md-start text-center">
                                    <h3 className="sect-title mb-25" data-aos="fade-up" data-aos-delay={100}>Proyectos Relacionados
                                    </h3>
                                </div>
                            </div>
                        </div>
                        {/* CaseSliderOne start */}
                        <CaseSliderOne />
                        {/* CaseSliderOne end */}
                    </div>
                </section>
                {/*latest-case-work end*/}

                {/*cuysoft-newsletter start*/}
                <NewsletterTwo />
                {/*cuysoft-newsletter end*/}

                {/* FooterThree start */}
                <FooterThree />
                {/* FooterThree end */}

            </div>

        </Fragment>
    )
}

export default ProjectDetails